const OneWayExemptionPeriodicity = [
  {
    id: 1,
    gpText: "Everyday",
  },
  {
    id: 2,
    gpText: "Working days only",
  },
  {
    id: 3,
    gpText: "Weekends",
  },
  {
    id: 7,
    gpText: "Monday only",
  },
  {
    id: 8,
    gpText: "Tuesday only",
  },
  {
    id: 9,
    gpText: "Wednesday only",
  },
  {
    id: 10,
    gpText: "Thursday only",
  },
  {
    id: 11,
    gpText: "Friday only",
  },
  {
    id: 12,
    gpText: "Saturday only",
  },
  {
    id: 13,
    gpText: "Sunday only",
  },
  {
    id: 14,
    gpText: "Public and Bank Holidays",
  },
  {
    id: 15,
    gpText: "Continuous",
  },
];

export default OneWayExemptionPeriodicity;